import { cn } from "@/lib/utils";
import { ReactNode, forwardRef } from "react";
import { Link, LinkProps } from "react-router-dom";

type ButtonLinkProps = LinkProps & {
  children?: ReactNode;
  isPending?: boolean;
  variant?: "primary" | "secondary" | "tertiary";
  className?: string;
};

const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>(
  ({ variant = "primary", children, isPending, className = "", ...props }, ref) => {
    let style =
      variant === "primary"
        ? "bg-primary text-white"
        : variant === "secondary"
        ? "bg-secondary text-white"
        : "bg-white text-black";

    return (
      <Link
        className={cn(
          `flex h-[60px] w-full items-center justify-center rounded-full p-5 text-lg font-semibold uppercase`,
          style,
          className,
        )}
        ref={ref}
        {...props}
      >
        {isPending && (
          <div className="mr-2 h-[25px] w-[25px] animate-spin rounded-full border-4 border-gray-500 border-t-gray-800" />
        )}
        {children}
      </Link>
    );
  },
);

ButtonLink.displayName = "ButtonLink";
export default ButtonLink;
